import React from "react";
import "./Plan.scss";
import { useNavigate } from "react-router-dom";

const Plan = () => {
  const navigate = useNavigate();
  const plans = [
    {
      name: "Dogs",
      description:
        "Proper dog care includes providing a balanced diet, regular exercise, grooming, and routine vet checkups to ensure good health. Sheltering should offer a safe, comfortable space with adequate warmth, ventilation, and protection from extreme weather. A loving and secure environment is essential for their well-being and happiness.",
      imgSrc: "/dog.jpg",
    },
    {
      name: "Cats",
      description:
        "Caring for a cat means providing a balanced diet, regular grooming, and plenty of playtime to keep them active and healthy. Their shelter should be a cozy retreat with comfy hiding spots, scratching posts, and a clean litter box. A loving, stress-free environment ensures your feline friend stays happy, relaxed, and full of purrs!",
      imgSrc: "/cat.jpg",
    },
    {
      name: "Birds",
      description:
        "Keeping your feathered friend happy starts with a nutritious diet, a clean and cozy cage, and plenty of social interaction. Their home should be a spacious, breezy haven filled with fun perches, engaging toys, and protection from harsh weather. With love, care, and a lively environment, your bird will thrive, chirping and singing with joy!",
      imgSrc: "/bird.jpg",
    },
  ];

  return (
    <div className="plan-container">
      <h3>We Specialize In Our Passion</h3>
      <h2>Caring For Pets & Sheltering</h2>
      <div className="planpage">
        {plans.map((plan, index) => (
          <div className="plan_card" key={index}>
            <div className="plan_image_container">
              <img src={plan.imgSrc} alt={plan.name} />
            </div>
            <h4>{plan.name}</h4>
            <p>{plan.description}</p>
            <button
              className="plan_button"
              onClick={() => navigate(`/plans/${plan.name.toLowerCase()}`)}
            >
              <span>Know more</span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plan;
